
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const FrenchettePage = lazy(() => import('../pages/project/frenchette/page'));
const WildCherryPage = lazy(() => import('../pages/project/wildcherry/page'));
const LeRockPage = lazy(() => import('../pages/project/lerock/page'));
const LeVeauDorPage = lazy(() => import('../pages/project/leveaudor/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/project/frenchette',
    element: <FrenchettePage />,
  },
  {
    path: '/project/wildcherry',
    element: <WildCherryPage />,
  },
  {
    path: '/project/lerock',
    element: <LeRockPage />,
  },
  {
    path: '/project/leveaudor',
    element: <LeVeauDorPage />
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;